import { createMuiTheme } from '@material-ui/core/styles';

const defaultTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#006CFF',
      contrastText: '#FFFFFF'
    },
    success: {
      main: '#6ABC6D',
      contrastText: '#FFFFFF'
    },
    error: {
      main: '#F55B50',
      contrastText: '#FFFFFF'
    },
    warning: {
      main: '#FFC107',
      contrastText: '#FFFFFF'
    }
  }
});

export default defaultTheme;
